import { render, staticRenderFns } from "./resources-list.vue?vue&type=template&id=1c62a104&"
import script from "./resources-list.vue?vue&type=script&lang=js&"
export * from "./resources-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports